export default function App() {
  return (
    <div
      style={{
        display: 'flex',
        margin: 'auto',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        width: '80%',
        maxWidth: 768,
      }}
    >
      <h1>Movies API</h1>
    </div>
  )
}
